// 把 broadcast / API 回傳的 interpolations 裡需要二次翻譯的 code 欄位預先翻譯
// （i18next $t nested 預設被 skipOnVariables 擋掉，所以要在 JS 端先處理）
//
// 處理欄位：
// - provider: enums.shipping_type.provider.<code>
// - role:     common.error.role.<code>
// - fields:   逗號分隔，每個用 common.error.address_field.<f>
// - error:    common.error.<code>（物流商 API 原始錯誤訊息找不到 key 時原樣顯示）
//
// @param {Function} t - i18next translate function
// @param {Object} interpolations - 原始 interpolations
// @returns {Object} 預翻譯後的 interpolations
export const translateErrorInterpolations = (t, interpolations) => {
  if (!interpolations) return {};
  return {
    ...interpolations,
    ...(interpolations.provider && {
      provider: t(`enums.shipping_type.provider.${interpolations.provider}`, { defaultValue: interpolations.provider })
    }),
    ...(interpolations.role && {
      role: t(`common.error.role.${interpolations.role}`, { defaultValue: interpolations.role })
    }),
    ...(interpolations.fields && {
      fields: String(interpolations.fields)
        .split(',')
        .map(f => t(`common.error.address_field.${f.trim()}`, { defaultValue: f.trim() }))
        .join('、')
    }),
    ...(interpolations.error && {
      error: t(`common.error.${interpolations.error}`, { defaultValue: interpolations.error })
    }),
  };
};
